import React from 'react';
import './App.css';
import Footer from './components/footer';
import Home from './Home';
import Solutions from './OurSolutions';
import Work from './OurWork';
import CaseStudies from './CaseStudies';
import Government from './Government';
import WhoWeAre from './WhoWeAre';
import Careers from './Careers';
import Support from './Support';
import Contact from './Contact';
import NavSub from './components/navSub'
import Nav from './components/navHome'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

const HomeContainer = () => (
  <div className="container">
    <Nav/>
    <Route exact path="/" component={Home} />
  </div>
)




function App() {
  return (
    <Router>
      <Switch>
      <Route exact path="/" component={HomeContainer}/>
        <div>
          <NavSub/>
          <Route path="/solutions" component={Solutions}/>
          <Route path="/work" exact component={Work}/>
          <Route path="/case" exact component={CaseStudies}/>
          <Route path="/government" exact component={Government}/>
          <Route path="/who" exact component={WhoWeAre}/>
          <Route path="/careers" exact component={Careers}/>
          <Route path="/support" exact component={Support}/>
          <Route path="/contact" exact component={Contact}/>
        </div>
      </Switch>
      <Footer/>
    </Router>  

  )}

export default App;
